<template>
  <el-container>
    <el-header>
      <div v-if="hasStatus">暂无异常。。。</div>
      <div v-else>
        <el-button size="medium" type="success" @click="openVideo()">
          {{ counts }}
        </el-button>
      </div>
      <audio src="@/assets/mp3.mp3" ref="music" loop>
        您的浏览器不支持音乐播放。
      </audio>
    </el-header>
    <el-main>
      <el-container class="m-con">
        <el-header class="m-h">
          <el-input
            placeholder="请输入被访者信息查询"
            v-model="keywords"
          ></el-input>
          <el-button @click="queryUnitDetails()" type="primary">查询</el-button>
          <el-button @click="lookdialogAddPassQuery()" type="primary"
            >查看添加记录</el-button
          >
          <el-button @click="openDoor()" type="danger">无登记开闸</el-button>
        </el-header>
        <el-main class="m-m">
          <el-table
            :data="unitListData"
            border
            :header-cell-style="{ background: '#409EFF', color: '#fff' }"
          >
            <el-table-column
              prop="userName"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="buildNum"
              label="小区"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="phoneNum"
              label="电话"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="houseNum"
              label="房号"
              align="center"
            ></el-table-column>
            <el-table-column label="添加来访记录" align="center">
              <template slot-scope="scope">
                <el-button @click="addPassData(scope.row)" type="primary"
                  >添加</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 添加通行记录框 -->
          <el-dialog title="添加记录" :visible.sync="dialogAddPass">
            <el-row class="d-row">
              <el-col :span="12">被访者姓名：</el-col>
              <el-col :span="12">
                {{ addUserinfo.userName }}
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">被访者电话：</el-col>
              <el-col :span="12">
                {{ addUserinfo.phoneNum }}
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">被访者区域：</el-col>
              <el-col :span="12">
                {{ addUserinfo.buildNum }}
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">被访者门号：</el-col>
              <el-col :span="12">
                {{ addUserinfo.houseNum }}
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">来访者姓名：</el-col>
              <el-col :span="12">
                <el-input
                  placeholder="请输入来访者姓名"
                  v-model="addUserinfo.visitorName"
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">来访者证件：</el-col>
              <el-col :span="12">
                <el-input
                  placeholder="请输入来访者证件"
                  v-model="addUserinfo.idNum"
                ></el-input>
              </el-col>
            </el-row>
            <el-row class="d-row">
              <el-col :span="12">来访者电话：</el-col>
              <el-col :span="12">
                <el-input
                  placeholder="请输入来访者电话"
                  v-model="addUserinfo.visitorPhone"
                ></el-input>
              </el-col>
            </el-row>
            <el-button @click="dialogAddPass = false" type="danger"
              >取消</el-button
            >
            <el-button @click="suerAddPass()" type="primary">确定</el-button>
            <el-dialog
              width="30%"
              title="开闸"
              :visible.sync="openDoorDialog"
              append-to-body
            >
              <el-button @click="openDoor()" type="danger">开启闸道</el-button>
            </el-dialog>
          </el-dialog>
          <!-- 查看通行记录 -->
          <el-dialog
            title="记录查询"
            :visible.sync="dialogAddPassQuery"
            fullscreen
            class="query-dia"
          >
            <el-container class="dialog-container">
              <el-header>
                <el-input
                  placeholder="请输入来访者姓名"
                  v-model="diaData.visitorName"
                ></el-input>
                <el-select v-model="diaData.isUnitId">
                  <el-option
                    v-for="(item, index) in addPassOption"
                    :key="index"
                    :label="item.unitName"
                    :value="item.isUnitId"
                  ></el-option>
                </el-select>
                <el-button @click="queryAddPass()" type="primary"
                  >查询</el-button
                >
              </el-header>
              <el-main>
                <el-table
                  :data="queryAddPassData"
                  border
                  :header-cell-style="{ background: '#409EFF', color: '#fff' }"
                >
                  <el-table-column
                    prop="visitorName"
                    label="姓名"
                  ></el-table-column>
                  <el-table-column
                    prop="visitorPhone"
                    label="电话"
                  ></el-table-column>
                  <el-table-column prop="idNum" label="证件"></el-table-column>
                  <el-table-column
                    prop="visitorTime"
                    label="登记时间"
                  ></el-table-column>
                  <el-table-column
                    prop="unitName"
                    label="小区"
                  ></el-table-column>
                  <el-table-column
                    prop="ntervieweeBuildNum"
                    label="区域"
                  ></el-table-column>
                  <el-table-column
                    prop="ntervieweeName"
                    label="被访者"
                  ></el-table-column>
                  <el-table-column
                    prop="ntervieweeHouseNum"
                    label="房号"
                  ></el-table-column>
                </el-table>
              </el-main>
              <el-footer>
                <!-- 分页 -->
                <el-pagination
                  @size-change="handleSizeChangedia"
                  @current-change="handleCurrentChangedia"
                  :current-page="diaData.currentPage"
                  :page-sizes="[10, 20, 30, 40]"
                  :page-size="diaData.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totaldia"
                >
                </el-pagination>
              </el-footer>
            </el-container>
          </el-dialog>
        </el-main>
      </el-container>
    </el-main>
    <el-footer>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      counts: 0,
      hasStatus: false,
      timer: null,
      abnormalList: [],
      keywords: "",
      pageSize: 10,
      currentPage: 1,
      total: 0,
      unitListData: [], //小区数据
      isUnitId: "", //小区ID
      openDoorList: {},
      dialogAddPass: false,
      openDoorDialog: false, //内层
      dialogAddPassQuery: false, //查询通讯记录
      addUserinfo: {
        visitorName: "",
        visitorPhone: "",
        idNum: "",
        uid: ""
      },
      queryAddPassData: [], //添加记录表
      addPassOption: [],
      totaldia: 0,
      diaData: {
        currentPage: 1,
        pageSize: 10,
        uid: "",
        isUnitId: "",
        visitorName: ""
      },
      ws: ""
    };
  },
  computed: {
    ...mapGetters(["userinfo"])
  },
  watch: {
    counts(newcount, oldcount) {
      if (newcount == 0) {
        this.hasStatus = true;
      }
      if (oldcount < newcount) {
        this.$refs.music.play();
      } else {
        this.$refs.music.pause();
      }
    }
    // openDoorDialog(newval) {
    //   if (!newval) {
    //     this.openDoorList = {}; //清空
    //     this.unitListData = [];
    //   }
    // }
  },
  created() {},
  mounted() {
    this.initWebsocket();
    // this.queryUserAll();
  },
  destroyed() {
    clearInterval(this.timer);
    // this.ws.onclose = this.websocketClose;
  },
  methods: {
    getAbnormal() {
      let url = "dapi/dri/getAbnormal";
      let params = { uid: this.userinfo.uid };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200 && data.data.length > 0) {
          this.hasStatus = false;
          this.abnormalList = data.data;
          this.counts = data.data.length;
        } else {
          this.hasStatus = true;
          this.counts = 0;
        }
      });
    },
    /*
     **  @description websocket
     **  @param {}
     **  @return
     **  @author shipingan
     */
    initWebsocket() {
      this.getAbnormal();
      this.timer = setInterval(() => {
        this.getAbnormal();
      }, 2000);
      // const wsURL = "ws://121.40.121.90:8082"
      // // const wsURL = "ws://172.18.0.15:8082";
      // this.ws = new WebSocket(wsURL);
      // this.ws.onopen = this.websocketOnopen;
      // this.ws.onmessage = this.websocketOnmessage;
      // this.ws.onerror = this.websocketOnerror;
    },
    // websocketOnopen() {
    //   console.log("连接成功");
    //   // let params = {
    //   //   uid: this.userinfo.uid,
    //   //   // sessionId: this.userinfo.uid,
    //   //   // status: 200,
    //   // };
    //   let params = this.userinfo.uid
    //   this.ws.send(params);
    // },
    // websocketOnerror() {
    //   this.initWebsocket();
    // },
    // websocketOnmessage(e) {
    //   this.getAbnormal();
    // },
    // websocketClose() {
    //   console.log("websocket 关闭");
    // },
    /*
     **  @description 打开视频
     **  @param {}
     **  @return
     **  @author shipingan
     */
    openVideo() {
      let params = {
        PktType: "VideoRealPlay",
        No: "1",
        Params: {
          DeviceName: "测试",
          DeviceNumber: this.abnormalList[0].device_number,
          MAC: this.abnormalList[0].device_mac,
          CloudID: this.abnormalList[0].device_cloud_id,
          ExtIp: "",
          IntIP: "",
          MediaPort: 34567,
          User: "admin",
          Pwd: "",
          Channel: "1",
          Preset: 1,
          type: 13,
          path: "",
          Stream: 1,
          remoteType: "门禁",
          PreRecord: ""
        }
      };
      this.$axios
        .post("http://127.0.0.1:10001", JSON.stringify(params))
        .then(res => {});
      this.openDoorList = { ...this.abnormalList[0] };
      this.removeAbnormal();
    },
    /*
     **  @description 移除门禁异常
     **  @param {}
     **  @return
     **  @author shipingan
     */
    removeAbnormal() {
      let url = "/dapi/dri/deleteResultList";
      let params = { ...this.abnormalList[0] };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "正确处理异常"
          });
          this.isUnitId = this.openDoorList.is_unit_id;
          this.getAllUnitList(this.isUnitId);
          this.getAbnormal();
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 查询小区住户信息
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryUserAll() {
      let url = "/dapi/u/getUserByUid";
      let params = {
        uid: this.userinfo.uid
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (
          data.parentId == "" ||
          data.parentId == undefined ||
          data.parentId == null
        ) {
          this.$message.error("未查询到小区数据");
        } else {
          //获取到小区ID
          this.isUnitId = data.parentId;
          this.getAllUnitList(this.isUnitId);
        }
      });
    },
    /*
     **  @description 查询数据
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getAllUnitList(isUnitId) {
      let url = "/dapi/u/likeUserByName";
      let params = {
        isUnitId: isUnitId,
        keywords: this.keywords,
        pageSize: this.pageSize,
        currentPage: this.currentPage
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.unitListData = data.data;
          this.total = data.rowCount;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 点击模糊查询
     **  @param {}
     **  @return
     **  @author shipingan
     */
    queryUnitDetails() {
      this.getAllUnitList(this.isUnitId);
    },
    /*
     **  @description 添加通行记录
     **  @param {}
     **  @return
     **  @author shipingan
     */
    addPassData(row) {
      this.addUserinfo.uid = this.userinfo.uid;
      Object.assign(this.addUserinfo, row);
      this.dialogAddPass = true;
    },
    /*
     **  @description 确认添加
     **  @param {}
     **  @return
     **  @author shipingan
     */
    suerAddPass() {
      let url = "/dapi/u/manualSaveVisitor";
      let params = { ...this.addUserinfo };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: "上传成功"
          });
          this.openDoorDialog = true;
          this.dialogAddPass = false;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 开启闸道
     **  @param {}
     **  @return
     **  @author shipingan
     */
    openDoor() {
      if (this.openDoorList.is_estate_id == undefined) {
        this.$message("暂无来访");
        return;
      }
      this.$confirm("是否为您正则处理的来访人员开闸", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //请求开闸接口
          this.sureOpen(this.openDoorList);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
          this.openDoorList = {}; //清空
          this.unitListData = [];
        });
    },
    /*
     **  @description 开闸接口
     **  @param {}
     **  @return
     **  @author shipingan
     */
    sureOpen(alldata) {
      let url = "/dapi/dri/manualOpenDoor";
      let params = { ...alldata };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.$message({
            type: "success",
            message: data.message
          });
          this.openDoorList = {}; //清空
          this.unitListData = [];
          this.openDoorDialog = false;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 查询登记记录
     **  @param {}
     **  @return
     **  @author shipingan
     */
    lookdialogAddPassQuery() {
      this.queryAddPass();
      this.getAllUnit(); //获取小区
      this.dialogAddPassQuery = true;
    },
    queryAddPass() {
      let url = "/dapi/u/getManualVisitorList";
      this.diaData.uid = this.userinfo.uid;
      let params = {
        ...this.diaData
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (res.status == 200) {
          this.totaldia = data.rowCount;
          this.queryAddPassData = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 查询旗下的小区
     **  @param {}
     **  @return
     **  @author shipingan
     */
    getAllUnit() {
      let url = "/dapi/u/getUnitListByUid";
      let params = { uid: this.userinfo.uid };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        let data = res.data;
        if (data.status == 200) {
          this.addPassOption = data.data;
        } else {
          this.$message.error(data.message);
        }
      });
    },
    /*
     **  @description 分页
     **  @param {}
     **  @return
     **  @author shipingan
     */
    handleSizeChange(val) {
      this.diaData.pageSize = val;
    },
    handleCurrentChange(val) {
      this.diaData.currentPage = val;
    },
    handleSizeChangedia(val) {
      this.diaData.pageSizedia = val;
    },
    handleCurrentChangedia(val) {
      this.diaData.currentPagedia = val;
    }
  }
};
</script>
<style lang="less" scoped>
@box-shadow: 0 0 10px #ccc;
.el-container {
  .el-header {
    line-height: 60px;
    box-shadow: @box-shadow;
  }
  .el-main {
    .m-con {
      min-width: 640px;
      .m-h {
        text-align: left;
        .el-input {
          width: 300px;
          margin-right: 20px;
        }
      }
      .m-m {
        padding: 20px 0;
        .d-row {
          padding: 10px;
          .el-col {
            .el-input {
              width: 60%;
            }
          }
        }
      }
    }
  }
}

.dialog-container {
  height: 100%;
  .el-header {
    display: flex;
    .el-input {
      max-width: 240px;
    }
    .el-select {
      margin: 0 16px;
    }
    .el-button {
      margin: 16px;
    }
  }
}
.query-dia {
  /deep/.el-dialog__header {
    border-bottom: 1px solid #ccc !important;
  }
  /deep/.el-dialog__body {
    height: calc(100% - 120px) !important;
  }
}
</style>
